export { default as StrategyMapMarkers } from './StrategyMapMarkers';
